<template>
  <div class="ag-rdp-lrp-list position-relative">
    <ag-card :module="module"></ag-card>
    <ag-pdp-lrp-modal :selected-row="selectedRow" :selected-server="selectedServer" :zones="zones"
      @formsuccess="serverFormSuccess">
    </ag-pdp-lrp-modal>
    
    <ag-pdp-lrp-choose-modal ref="chooseModal" @formsuccesschoose="serverFormSuccessChoose" />
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import PdpLrpList from "@/helpers/pages/PdpLrpList";
import { Roles } from "@/helpers/enums/Roles";
import AgPdpLrpModal from "@/components/ag-pdp-lrp-modal/index.vue";
import AgPdpLrpChooseModal from "@/components/ag-pdp-lrp-choose-modal/index.vue";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useStore } from "@/store";
import { notify } from "@kyvg/vue3-notification";
import Swal from 'sweetalert2';
const store = useStore();

export default defineComponent({
  name: "PdpLrpList",
  components: { AgCard, AgPdpLrpModal ,AgPdpLrpChooseModal},
  setup() {
    const selectedRole = localStorage.getItem("selectedRole");
    const selectedScopeId = localStorage.getItem("selectedScopeId");
    const partner = localStorage.getItem("partner");
    const partnerGuid = partner ? JSON.parse(partner)?.guid : "";
    const company = localStorage.getItem("company");
    const companyGuid = company ? JSON.parse(company)?.companyGuid : "";
    const site = localStorage.getItem("site");
    const siteGuid = site ? JSON.parse(site)?.key : "";
    const group = localStorage.getItem("group");
    const groupGuid = group ? JSON.parse(group)?.key : "";
    
    let filter = ref({
      page: 1,
      limit: 5,
      sortColumn: "serverName",
      sortDir: "asc",
      PdpLrpPageRole: selectedRole, 
      SelectedScopeId: selectedScopeId 
    });

    const module = ref(PdpLrpList);
    const selectedServer = ref(null);
    const zones = ref(null);
    let response = "";

    const getList = async (filters = filter.value) => {
      try {
       
        filters.PdpLrpPageRole = selectedRole;
        filters.SelectedScopeId = selectedScopeId;
        filters.PartnerId = partnerGuid;
        filters.CompanyId = companyGuid;
        filters.SiteId = siteGuid;
        filters.GroupId = groupGuid;

        const body = { 
          filters, 
          options: module.value.component.options
        };
        response = await store.dispatch(GeneralActionTypes.GET_SERVERS, body);

        if (response.entityData) {
          module.value.component.options.rows = response.entityData;
          module.value.component.options.total = response.totalCount;
          selectedServer.value = response.entityData;
        }
      } catch (error) {
        console.error("Error fetching list:", error);
      }
    };

    const getServerById = async (id) => {
      const getServer = await store.dispatch(GeneralActionTypes.GET_SERVER_BY_ID, id);
      return getServer;
    };
    const getCompanyServerById = async (id, companyGuid) => {
      const getServer = await store.dispatch(GeneralActionTypes.GET_COMPANY_SERVER_BY_ID, { id, companyGuid });
      return getServer;
    };

    
    const getZones = async () => {
      const zoneList = await store.dispatch(GeneralActionTypes.GET_ZONES);
      zones.value = zoneList;
    };

    const editFunction = async (server) => {
      const serverData = await getServerById(server);
      const selected = serverData.entityData;
      selectedServer.value = { ...selected };
      store.dispatch(GeneralActionTypes.SET_COMPKEY, store.getters.compKey + 1);
    };

    const testConnection = async (data) => {
      let connection = "";
      let icon = "warning";
      connection = await store.dispatch(GeneralActionTypes.GET_TEST_CONNECTION_BY_SERVERID, data);
      if (connection.entityData && connection.entityDataCount > 0) {
        const firstMessageSuccess = connection.entityData[0]?.message.includes("was  successful");
        const secondMessageSuccess = connection.entityData[1]?.message.includes("was  successful");

        if (firstMessageSuccess && secondMessageSuccess) {
          icon = "success"
        } else if (firstMessageSuccess || secondMessageSuccess) {
          icon = "info";
        }

        const messageHtml = connection.entityDataCount === 1
          ? `${connection.entityData[0].message}`
          : `${connection.entityData[0].message}<br>${connection.entityData[1].message}`;

        Swal.fire({
          title: connection.message,
          icon: icon,
          html: messageHtml,
          confirmButtonText: "Okay",
        });
      }
      return icon;
    };

    const deleteFunction = async (id) => {
      const serverData = selectedRole !== Roles.AGMSAdmin 
      ? await getCompanyServerById(id,companyGuid) 
      : await getServerById(id);
      
      const itemToDelete = serverData.entityData;
      selectedServer.value = { ...itemToDelete };

      Swal
        .fire({
          title: "Are You Sure?",
          icon: "warning",
          text: "You are about to delete the selected item!",
          showCancelButton: true,
          confirmButtonText: "Delete",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (selectedRole === Roles.AGMSAdmin){
              store
              .dispatch(GeneralActionTypes.DELETE_SERVER, selectedServer.value)
              .then((res) => {
                let message = '';
                if (res.entityData.defaultSettingsCheck) {
                  message += "At least two Default Server record must exist in the system.";
                }
                if (res.entityData.pdpServerCheck) {
                  if (message) {
                    message += '<br>';
                  }
                  message += "At least two PDP Server record must exist in the system.";
                } 
                if (res.entityData.lrpServerCheck) {
                  if (message) {
                    message += '<br>';
                  }
                  message += "At least two LRP Server record must exist in the system.";
                }
                if (message) {
                  Swal.fire("Info", message, "info");
                }
                else if (
                  Number(res.statusCode) == 200 ||
                  Number(res.status) == 200
                ) {
                  notify({
                    title: "Deleted!",
                    type: "success",
                    text: "The server has been deleted.",
                    duration: 5000,
                  });
                } else {
                  Swal.fire("Error", res.data.Errors, "error");
                }
              })
              .catch((e) => {
                Swal.fire("Error", JSON.stringify(e.Message), "error");
              })
              .finally(() => {
                const options = module.value.component.options;
                options.page = 1;
                store.dispatch(GeneralActionTypes.GET_SERVERS, {
                  options: options,
                  filters: {},
                });
              });
            }
            else {
              const requestData = {
                ServerViewModel: selectedServer.value, 
                PdpLrpPageRole: selectedRole, 
                SelectedScopeId: selectedScopeId ?? null,
                PartnerId: partnerGuid,
                CompanyId: companyGuid,
                SiteId: siteGuid,
                GroupId: groupGuid
              };

              store
                .dispatch(GeneralActionTypes.DELETE_SELECT_SERVER, requestData)
                .then((res) => {
                  if (res.entityData.defaultSettingsCheck) {
                    notify({
                      title: "Info!",
                      type: "info",
                      text: "The default server cannot be deleted.",
                      duration: 4000,
                    });
                  }
                  else if (Number(res.statusCode) == 200 || Number(res.status) == 200) {
                    notify({
                      title: "Deleted!",
                      type: "success",
                      text: "The server has been deleted.",
                      duration: 4000,
                    });
                    getList();
                  } else {
                    Swal.fire("Error", res.data.Errors, "error");
                  }
                })
                .catch((e) => {
                  Swal.fire("Error", JSON.stringify(e.Message), "error");
                })
            }
          }
        });
    };
    
      
    return {
      getList,
      module,
      getZones,
      getServerById,
      getCompanyServerById,
      selectedServer,
      zones,
      editFunction,
      deleteFunction,
      testConnection
    }
  },
  data() {
    return {
      Roles: Roles,
    };
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  methods: {
    serverFormSuccess() {
      this.getList();
    },
    
    serverFormSuccessChoose() {
      setTimeout(() => {
        window.location.reload();
      }, 700); 
    }

   
  },
  mounted() {
    this.getList();
    this.getZones();
  },
});
</script>

<style>
.ag-rdp-lrp-list #ag-table .ag-icon {
  font-size: 1.1em !important;
}

.ag-rdp-lrp-list .ag-badge {
  line-height: auto;
  margin-left: 0px;
  margin-top: 3px;
  display: flex;
  align-items: center;
}

.ag-icon_edit {
  cursor: pointer;
}

.badge {
  padding: .25em .4em !important;
  font-size: 75% !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  text-align: center !important;
  white-space: nowrap !important;
  vertical-align: baseline !important;
  border-radius: .25rem !important;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !important;
}
</style>
